import { getAuth, onAuthStateChanged } from "firebase/auth";

export function waitForAuthState(timeoutMs = 10000) {
  const auth = getAuth();

  if (auth.currentUser !== null) {
    return Promise.resolve(auth.currentUser);
  }

  return new Promise((resolve, reject) => {
    let finished = false;

    const unsubscribe = onAuthStateChanged(
      auth,
      (user) => {
        if (finished) return;
        finished = true;
        clearTimeout(timer);
        unsubscribe();
        resolve(user);
      },
      (error) => {
        if (finished) return;
        finished = true;
        clearTimeout(timer);
        unsubscribe();
        reject(error);
      }
    );

    const timer = setTimeout(() => {
      if (finished) return;
      finished = true;
      unsubscribe();
      reject(new Error("Authentication timeout."));
    }, timeoutMs);
  });
}

export async function getFirebaseToken() {
  const user = await waitForAuthState();

  if (!user) {
    throw new Error("User is not signed in.");
  }

  return await user.getIdToken();
}